import { render } from "./HeroQuickInfo.vue?vue&type=template&id=38bb563e"
import script from "./HeroQuickInfo.vue?vue&type=script&lang=js"
export * from "./HeroQuickInfo.vue?vue&type=script&lang=js"

import "./HeroQuickInfo.vue?vue&type=style&index=0&id=38bb563e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/HeroQuickInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38bb563e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38bb563e', __exports__)) {
    api.reload('38bb563e', __exports__)
  }
  
  module.hot.accept("./HeroQuickInfo.vue?vue&type=template&id=38bb563e", () => {
    api.rerender('38bb563e', render)
  })

}


export default __exports__